import React from 'react';
import { useTranslation } from 'react-i18next';

export default function StickyFooter() {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-blue-700 text-white">
      <div className="container mx-auto px-2 md:px-4 py-2 md:py-4">
        <div className="flex flex-row flex-wrap items-center justify-center max-w-5xl mx-auto gap-2 md:gap-4">
          {/* Left Section */}
          <div className="flex items-center gap-1 md:gap-2">
            <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-emerald-400 rounded-full animate-pulse"></div>
            <span className="text-gray-300 text-xs md:text-sm">{t('easyCredit.footer.questions')}</span>
          </div>
          
          {/* Center Section - Phone Number */}
          <a 
            href={`tel:${t('easyCredit.footer.phoneNumber')}`}
            className="flex items-center gap-1.5 md:gap-3 px-2 md:px-4 py-1 bg-white bg-opacity-10 rounded-lg border border-white border-opacity-20 hover:bg-opacity-20 transition-all cursor-pointer"
          >
            <div className="flex items-center justify-center w-6 h-6 md:w-8 md:h-8 bg-emerald-600 rounded-full">
              <svg className="w-3 h-3 md:w-4 md:h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
            </div>
            <span className="font-bold text-sm md:text-md tracking-wide">{t('easyCredit.footer.phoneNumber')}</span>
          </a>
          
          {/* Right Section */}
          <div className="flex items-center gap-1 md:gap-2">
            <svg className="w-3 h-3 md:w-4 md:h-4 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-gray-300 text-xs md:text-sm">{t('easyCredit.footer.availablityTimes')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
